import React from 'react';
import { PitechLoader, PitechPageLoader } from './PitechLoader';

// Re-export with old names for backward compatibility
export const IOSLoadingSpinner: React.FC<{
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}> = ({ size = 'md', className }) => {
  const sizeMap = {
    sm: 'sm' as const,
    md: 'md' as const,
    lg: 'lg' as const,
  };
  
  return <PitechLoader size={sizeMap[size]} className={className} variant="orbit" />;
};

export const IOSPageLoadingOverlay: React.FC = () => {
  return <PitechPageLoader text="Loading..." />;
};
